export const emailPattern =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,30}$/;
export const otpPattern = /^[0-9]{6}$/;
export const swedishPersonalNumberPattern = /^[0-9]{8}[-+]?[0-9]{4}$/;
export const finnishPersonalNumberPattern = /^\d{6}[+-A]\d{3}[0-9A-Y]$/;
export const phoneNumberPattern = /^\+?[0-9 -]{6,17}$/;
export const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{10,}$/;
export const sharedInboxCodePattern = /^[0-9]{3}( )?[0-9]{3}$/;
